import { render, staticRenderFns } from "./ComponentConfig.vue?vue&type=template&id=6913ed1c"
import script from "./ComponentConfig.vue?vue&type=script&lang=js"
export * from "./ComponentConfig.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports